<template>
  <div class="ifirmfg">
    <sub-title text="民商法类热门法规" />
    <div class="ifhlist">
      <div
        class="ifhitem flex_start"
        v-for="(item, index) in 10"
        :key="index"
        @mouseover="itemact = index"
      >
        <div
          class="sortp center"
          :class="{
            sortp1: index == 0,
            sortp2: index == 1,
            sortp3: index == 2,
          }"
        >
          {{ index + 1 }}
        </div>
        <div class="rtext">
          <div class="bt ellipsis">中华人民共和国城市房地产管地产管产</div>
          <div class="xx" v-if="itemact == index">
            根据2018年10月26日第十三届全国人民代表大会常务委员会第六次会
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  data: () => ({
    itemact: 0,
  }),
};
</script>

<style lang="scss" scoped>
.ifirmfg {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  padding: 23px 12px 10px;
  .ifhlist {
    margin-top: 30px;
    font-size: 14px;
    color: #666666;
    .ifhitem {
      align-items: flex-start;
      margin: 10px 0;
      .sortp {
        color: #0183ff;
        margin-right: 10px;
        width: 20px;
        height: 20px;
        background: #d8ecff;
        border-radius: 2px;
        font-size: 12px;
      }

      .sortp1 {
        background-color: #ff6600;
        color: #fff;
      }
      .sortp2 {
        background-color: #ff8b3e;
        color: #fff;
      }
      .sortp3 {
        background-color: #f4ab2b;
        color: #fff;
      }
      .rtext {
        width: 250px;
      }
      .bt {
        margin-bottom: 10px;
      }
      .xx {
        font-size: 12px;
        color: #999999;
        line-height: 20px;
      }
    }
  }
}
</style>